export default {
    version:'v1.9',// 版本号
    apiTimeout: 15000, // 默认15秒
    uploadTimeout: 30000, // 文件上传30秒
    lang: 'zh',// zh 中文 en 英文
    appId: process.env.VUE_APP_ID || '8000418004',// 应用id，支持环境变量覆盖
    baiduStatId: process.env.VUE_APP_BAIDU_STAT_ID || 'adedae9bc250561cc17e96dc1fb46079',// 百度统计ID，支持环境变量覆盖
}
